<template>
  <div>
    <el-drawer :destroy-on-close="true" :append-to-body="true" title="Ayarlar" :visible.sync="settings"
      :with-header="false">
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.time") }}</label>
          <el-slider :format-tooltip="formatTooltip" v-model="speed" :step="5" :min="10" :max="40" show-stops></el-slider>
        </div>
        <div class="col-md-12">
          <label for="">{{ $t("module.text_length") }}</label>
          <el-slider v-model="level" :step="1" :min="2" :max="5" show-stops></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
            }}</label>
          <el-switch style="margin-top: 8px" v-model="autoLevel" :active-text="$t('module.yes')" :active-value="1"
            :inactive-value="0" :inactive-text="$t('module.no')">
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme">
      <paused v-if="pause" @click="
          $root.$emit('pause', !pause);
          pause = false;
        "></paused>
      <a href="javascript:;" @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        " class="pause">
        <i :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
      </a>
      <a href="javascript:;" v-if="config == null || config == undefined" @click.stop="settings = true" class="settings">
        <i class="el-icon-setting"></i>
      </a>
      <div v-if="interval2 == null" class="dark-inverted" style="
          font-size: 20px;
          border-radius: 5px;
          cursor: pointer;
          display: inline-block;
          overflow: hidden;
          overflow-y: auto;
          height: 500px;
          width: 100%;
          padding: 10px 15px;
        ">
        <span v-for="(item, index) in options" @click="pick(index)" :style="{
            background: getColor(item),
            marginRight: 5 + 'px',
            color: getColor(item) == 'rgb(28, 68, 156)' ? 'white' : '',
          }">
          {{ item.letter }}
        </span>
      </div>
      <div v-else class="dark-inverted">
        {{ $t("module.kelimeavi.description", { currentLetter }) }}
      </div>
    </div>
    <div :style="{ width: wrapper.width + 'px' }" style="margin: 0 auto; border-radius: 0px">
      <div class="progress" style="border-radius: 0px; height: 5px">
        <div class="progress-bar" style="border-radius: 0px" :style="{
            width: (currentCounter / speed) * 100 + '%',
            height: '40px',
          }"></div>
      </div>
      <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: row;
        " v-if="pause == false">
        <span class="dark-inverted">{{ $t("module.kelimeavi.description", { currentLetter }) }}
          <br />
          <span style="font-size: 22px; font-weight: bold" class="dark-inverted true-count">{{
            options.filter((k) => k.slug === $slugify(currentLetter.trim()))
            .length
            }}/{{
            options.filter(
            (k) =>
            k.slug === $slugify(currentLetter.trim()) && k.picked == true
            ).length
            }}</span>
        </span>
        <div style="display: flex; flex-direction: row">
          <span class="num" style="display: flex; align-items: center; justify-content: center">
            <div style="
                position: relative;
                z-index: 9999;
                background-color: red;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                color: white;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 22px;
              ">
              <i class="fas fa-times"></i>
            </div>
            <span style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: red;
                height: 40px;
                padding-left: 20px;
                margin-left: -20px;
                z-index: 1;
                position: relative;
                line-height: 45px;
                padding-right: 10px;
              ">{{ totalFalse }}</span>
          </span>
          <span class="num" style="display: flex; align-items: center; justify-content: center">
            <span style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: rgb(28, 68, 156);
                height: 40px;
                padding-right: 20px;
                margin-right: -20px;
                z-index: 0;
                position: relative;
                line-height: 45px;
                padding-left: 10px;
              ">{{ totalTrue }}</span>
          </span>
          <svg height="40px" viewBox="0 0 512 512" width="40px" xmlns="http://www.w3.org/2000/svg"
            style="position: relative; z-index: 2">
            <path
              d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
              fill="rgb(28, 68, 156)" />
            <path
              d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0"
              fill="#fafafa" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
export default {
  name: "GozEsnekligi",
  props: ["config"],
  data() {
    return {
      pause: false,
      speed: 40,
      top: 0,
      left: 0,
      word: null,
      rotate: 0,
      currentCounter: 40,
      startCounter: 3,
      level: 2,
      levels: [
        {
          metin: `Teknolojik cihazları hayatımızın her sahasında görmek mümkün. Ancak teknolojiyi bilinçsiz kullanmaktan en fazla zararı yeni nesil görüyor. Çünkü doğdukları andan itibaren akıllı cihazlar onların ellerine “elektronik emzik” niyetiyle veriliyor. Bu susturucu emzikle başlayan tanışma ileride teknoloji bağımlılığına dönüşüyor. Bu bağımlılığa dikkat çekmek için “Teknolojisiz Bir Gün” adlı sosyal sorumluluk projesi başlatıldı. Projenin çıkış noktası şöyle açıklanıyor: Teknoloji, yemek gibi bir ihtiyaç lakin yemeğin fazlasının obeziteye yol açması gibi teknolojinin fazlası da “teknoloji bağımlılığına” yol açıyor.

Ekran bağımlılığı erkeklerde mobil oyun, bayanlarda sosyal medyayı kontrol etme isteğiyle ortaya çıkarıyor. Ortaöğretim çağındaki bir çocuk yılda 1000 saatini okulda geçirirken 1500 saatini TV ve bilgisayar başında geçiriyor. Gençler her gün zamanlarının 229 dakikasını cep telefonu kullanarak öldürüyor. Türkiye’de bir kişi günde ortalama 6 saat TV izlerken kitap okumaya yalnızca 1 dakika ayırıyor. Bütün bunlara çözüm olarak da haftada bir gün “teknoloji diyeti” tavsiye ediliyor. Kadın, erkek, yaşlı, genç farklı kişilere “Teknolojik cihazlar olmadan, bir gününüzü nasıl geçirirdiniz?” sorusuna en fazla verilen cevap “Kitap okurum.” oluyor. Diğer cevaplarsa “Çocuklarımla vakit geçiririm, oyun oynarım, yürüyüş yaparım, resim çizerim, yeni yerler keşfederim, kütüphaneye giderim...” şeklinde sıralanıyor.
Eğer siz de teknolojiyi haddinden fazla kullanıyorsanız teknoloji diyeti yaparak sevdiklerinize vakit ayırıp neler kaçırdığınızı fark edebilirsiniz.`,
          levels: [
            {
              find: "teknoloji",
              level: 5,
            },
            {
              find: "fazla",
              level: 3,
            },
            {
              level: 2,
              find: "teknolojik",
            },
          ],
        },
        {
          metin:
            "“Küçük Prens’in Güzel Hikayesi” adlı bu nefis kitap, Antonie de Saint Exuperynin yazdığı Küçük Prens öyküsünün tam metninin yanı sıra yayımlanmayan bir bölümünü, Küçük Prens karakterinin orijinal çizimlerini ve Küçük Prens üzerine yazılmış makaleleri içeriyor.",
          levels: [
            {
              find: "prens",
              level: 4,
            },
            {
              find: "küçük",
              level: 4,
            },
          ],
        },
        {
          metin:
            "Yaşadığımız dünyaya karşı taşıdığımız sorumlulukları fark etmemiz için en ideal zamanlar ilk çocukluk yıllarımız. Yere çöp atmama, ağaçların dallarını kırmama, çiçekleri koparmama gibi birçok şey bu dönemde edindirilir. Bunda en büyük pay kitaplara ait. Eğitim Uzmanı Bilge Buhan Musa, geri dönüşüm üzerine çıkardığı dört yeni hikaye kitabıyla çocuklara çevre bilinci kazandırmayı hedefliyor. Bilge Buhan Musa, doğanın nasıl korunabileceğini kitaplarında verdiği yöntemlerle somutlaştırıp çocukların bunu davranışa kolayca dönüştürebileceklerini belirtiyor. Eğitimci yazarın yayımlanan hikaye serisi, çocukların kitaptaki kahramanlarla empati kurmalarını sağlıyor ve gezegenimize karşı sorumluluklarını yerine getirmelerine aracı oluyor. Bu hikaye serisi dört farklı kitaptan oluşuyor. “Yaşlı Çınar Ağacında kağıdın, “Meraklı Yeşil Şişede camın, “Beyaz Plastik Bardakta plastiğin geri dönüşümü anlatılıyor. “Geri Kazanım Atölyesinde ise kullandığımız eşyalardan geri dönüşüme gitmeden ne şekilde faydalanabileceğimiz dile getiriliyor.",
          levels: [
            {
              level: 4,
              find: "Geri",
            },
            {
              find: "hikaye",
              level: 3,
            },
            {
              find: "Karşı",
              level: 2,
            },
            {
              find: "Bilge",
              level: 2,
            },
          ],
        },
        {
          metin: `1950’li yılların başında istasyon, bir mola yeri olmaktan ziyade hayatın aktığı yerdi bizim kasabada. Kasabanın gençleri istasyonda buluşur, kalabalıkta kendilerini unuttururdu. 
Filmlerdeki gibi, gençler ilk kez burada göz göze gelirdi. İlk ayrılık burada yaşanır, askerlik veya çalışmak için büyük şehre gidenlerin ardından gözyaşı ilk kez burada dökülürdü. Ayrılığın acısı kadar buluşmanın sevinci de istasyondu. Ben de tezkere alıp gelen ağabeyimi burada beklemiştim. İki gün boyunca istasyona her gelen trende gözlerim ağabeyimi aramıştı. Nihayet ağabeyim trenden indiğinde boynuna sarılmış, dakikalarca ağlamıştım.`,
          levels: [
            {
              find: "Burada",
              level: 4,
            },
            {
              find: "İlk",
              level: 2,
            },
            {
              find: "Kez",
              level: 2,
            },
            {
              find: "ağabeyimi",
              level: 2,
            },
          ],
        },
        {
          metin: `Başınız ağrıyorsa “Kendinizi hangi konuda yargılıyorsunuz, uğraşıp baş edemediğiniz düşünceleriniz nelerdir?” sorularının cevabını bulmalısınız. Baş ağrılarının çoğu kendini acımasızca eleştirme, öz güven kayıpları ve kişinin, yaptığı her şeyi değersiz görmesiyle ilgilidir.
Migren türü baş ağrısı kendine ve her şeye kızan, oldukça mükemmeliyetçi olan, kendilerine acımasızca baskı yapan kişiler tarafından yaratılır. Migrende, yoğun olarak bastırılmış kızgınlık vardır.
Boyun fıtığı ve ağrıları; düşüncelerimizde esnek olmamak, yaşadığımız sorunların öteki yüzünü görememek, başka bir kişinin bakış açısını anlayamamaktan kaynaklanır.`,
          levels: [
            {
              find: "Baş",
              level: 3,
            },
            {
              find: "Acımasızca",
              level: 2,
            },
          ],
        },
        {
          metin: `Cumhuriyet Dönemi’nde Türkiye’deki yükseköğretimi incelemesi ve bir reform tasarısı hazırlaması için İsviçre’den Prof. Dr. Albert Malche davet edilmişti. Albert Malche bir rapor hazırlayarak Atatürk’e sunmuştu. Malche’nin hazırladığı raporu titizlikle inceleyen Atatürk düşüncelerini şu şekilde ifade etmiştir: “Bir milleti ancak ve ancak o milletin içinden çıkanlar yükseltebilir. Bir yabancı alimin fikirlerinden, görüşlerinden ve tetkiklerinden istifade edeceğiz fakat asıl çareyi, asıl kararı kendi içimizden çıkarmak mecburiyetindeyiz.”`,
          levels: [
            {
              find: "Bir",
              level: 4,
            },
            {
              find: "Malche",
              level: 3,
            },
            {
              find: "Albert",
              level: 2,
            },
          ],
        },
        {
          metin: `Geçirdiği kaza sonucu hastaneye kaldırılıp yoğun bakıma alınan ve Rus olduğu tahmin edilen felçli gence, Gülsüm Kabadayı adlı bir vatandaş sahip çıktı. Bu sahipsiz gencin ölümüne kadar geçen yaklaşık on yıllık sürede bakımını üstlendi. Gülsüm Kabadayı, çıktığı bir televizyon programında Rus muhabirin: “Bu gencin bakımı için gerekli gücü nereden alıyorsunuz?” sorusuna: “Allah’ımdan, devletimden, doktorlarımdan ve tüm Türk annelerinden.” diyerek cevap verdi.`,
          levels: [
            {
              level: 2,
              find: "Rus",
            },
            {
              level: 2,
              find: "Gülsüm",
            },
          ],
        },
        {
          metin: `Göçmen kuşlar sıcak bir ülkeye göç ederken yolda fırtınaya yakalanırlar. Bir ormanda konaklamaya karar verirler. Ormanda fırtınanın geçmesini beklerken çalıların arasında yem dolu bir çuval görürler. Yolculuk esnasında acıkan kuşlar çuvala doğru uçup yemlenmeye başlarlar. Fakat bu çuval, bir tuzaktır. Aniden üstlerine kalın iplerden yapılmış bir ağ düşer. Kuşlar hemen ağdan kurtulmak için çırpınırlar fakat başaramazlar. Lider kuş, diğer kuşlar dan çırpınmayı kesmelerini, buradan kurtulmanın imkansız olduğunu söyler. Diğer kuşlar da lider kuşa hak verirler. Çırpınmayı bırakıp başlarına gelecekleri beklemeye başlarlar. Boncuk adlı kuş ise bunu kabul etmez. Gagasıyla ağın ipini gagalamaya başlar. Lider kuş bu yaptığının faydasız olduğunu söylese de Boncuk aldırmaz. İpi iki saat boyunca gagalmaya devam eder. Sonunda yıpranan ip kopuverir ve ağda herkesin çıkabileceği kadar bir delik açılır. Böylece bütün kuşlar kurtulur ve neşeyle gökyüzüne doğru kanatlanır.`,
          levels: [
            {
              level: 5,
              find: "kuşlar",
            },
          ],
        },
        {
          metin: `Bir gece, kadının biri havaalanında bekliyordu. Uçağının kalkmasına daha epeyce zaman vardı. Havaalanındaki dükkandan bir kitap ve bir paket kurabiye alıp kendisine oturacak bir yer buldu. Kendisini kitabına kaptırmış olmasına rağmen yanında oturan adamın olabildiğince cüretkar bir şekilde aralarında duran paketten bir kurabiye aldığını fark etti; ne kadar görmezden gelse de. Bir taraftan kitabını okuyup kurabiyesini yerken bir taraftan da gözü saatteydi. Kurabiye hırsızı kurabiyeleri yavaş yavaş tüketirken kadının kulağı da saat tik taklarındaydı ama tik taklar sinirlenmesini engellemiyordu. Kendi kendine düşünüyordu: “Kibar bir insan olmasaydım şu adamın gözünü morartırdım!”`,
          levels: [
            {
              level: 5,
              find: "kurabiye",
            },
          ],
        },
        {
          metin: `Bir üniversite profesörü sosyoloji dersinde öğrencilerini gecekondu mahallesine gönderip orada yaşayan 200 genç üzerinde olgu araştırması yapmalarını istemişti. Öğrencilerinden her bir gencin geleceği konusunda değerlendirmede bulunmalarını istemişti. Öğrenciler her bir olgu için “Hiç şansı yok.” yorumunda bulunmuşlardı. Yirmi beş yıl sonra başka bir sosyoloji profesörünün karşısına aynı çalışma çıkmıştı. Profesör öğrencilerinden bu gençlerin akıbetinin ne olduğunu öğrenmelerini istedi. Öğrenciler, yöreden taşınan veya vefat eden 20 gencin dışında ulaşabildikleri 180 gençten 176 tanesinin doktor, avukat ve iş adamı olarak pek de sıradan olmayan başarılar elde ettiklerini buldular. Oldukça şaşıran profesör olayın üzerine gitmeye karar verdi.`,
          levels: [
            {
              level: 2,
              find: "sosyoloji",
            },
          ],
        },
        {
          metin: `Sınavda yer alan paragraflar incelendiğinde geçmiş yıllara göre metinlerin daha kısa geldiği görülmektedir. Buna karşın adaylar Paragrafta Anlam konusunda geçtiğimiz yıllara göre oldukça zorlandı. Ayrıca bu yıl Paragrafta Anlam konusunun büyük bir kısmını oluşturan paragrafa bağlı sorular, adayları metni tekrar tekrar okumaya iterek zaman yönetimi konusunda sıkıntı yaşamalarına sebep oldu. Geçtiğimiz yıllara göre bu yıl paragrafın içerisinde yer alan terimsel ifadeler azalmıştır fakat ÖSYM yine metinlerin çoğunu makalelerden seçtiği için terimsel ifadelere az da olsa rastlamaktayız. Her yıl olduğu gibi bu yıl da yardımcı düşünceyi buldurmaya yönelik sorular Paragrafta Anlamın önemli bir kısmını oluşturmaktadır.`,
          levels: [
            {
              level: 5,
              find: "yıl",
            },
          ],
        },
        {
          metin: `Birinci Dünya Savaşı’nda erkeklerin askere gitmesi önceden kadınlara kapalı olan ve “erkek işi” olarak adlandırılan birçok alanın kapılarını kadınlara açtı. Bunlardan biri de futboldu. Özellikle taşrada kadın futbolu hızla yaygınlaştı, hemen her köyde bir kadın futbol takımı kuruldu. Kadın futbolu, bir fabrikada çalışan işçilerin oluşturduğu Dick Kerr’in Hanımları adlı takımla çıkış yaptı. Molalarda fabrika avlusunda kendi aralarında oynayarak futbola başlayan kadınlar, 1917’de fabrikanın erkek işçilerinden oluşan bir takımla maç yaptı ve onları yendi. Bununla ünlenen kadın işçiler, daha sonra on binlerce seyircinin önünde harp malullerine ve muhtaç ailelere destek için maçlara çıktı. Ancak 1921'de İngiltere Futbol Federasyonu, anatomik yapılarının futbola uygun olmadığı ve oyunun doğurganlığa zarar verdiği gerekçesiyle kadınların maç yapmasını yasakladı. Fakat savaş bitse de “hanımlar” evlerine dönmedi. Savaşın yokluk ve zaruret ortamı bir kez kadınlara futbol sahalarını açmıştı ve onları, her fırsatta oynadıkları bu oyundan men etmek artık mümkün değildi.
`,
          levels: [
            {
              level: 5,
              find: "kadın",
            },
          ],
        },
        {
          metin: `Rivers, eski zamanlardan kalma çeşitli insan ürünü nesnelerle karşılaştıkça bu nesneler üzerinde çalışmak ve daha sonra onları sergilemek için yapılacak en iyi şeyin bir sınıflandırma girişimi olacağına karar verdi. II. Yaptığı araştırmalar sonucunda, ateşli silah tasarımında çok daha güçlü ve kusursuz tüfeklerin icat edilmesine yol açan, köklü ve yenilikçi bir değişimin yaşanmış olduğunun farkına vardı. III. Tarih öncesi eşyaları toplayarak bir koleksiyon oluşturmaya ve yapılan kazılar sırasında Britanya adaları ve Kuzey Avrupa’da ortaya çıkarılan tarihî eserleri ve eşyaları inceleyerek bu değişimin izini sürmeye başladı. IV. 1852 yılında İngiliz ordusu için yeni uzun namlulu tüfeklerin denenmesi ve bir kullanma kılavuzunun hazırlanmasıyla görevlendirilen Pitt-Rivers, böylelikle ateşli silahların tarihine ilgi duymaya başladı. V. Söz konusu nesneleri doğum yerlerine göre coğrafi olarak sınıflandırmak mı gerekiyordu, yoksa daha tatminkar bir sınıflandırma sistemi söz konusu olabilir miydi?
`,
          levels: [
            {
              level: 5,
              find: "bir",
            },
          ],
        },
        {
          metin: `Cervantes’in Don Kişot adlı eserinin Rus edebiyatına etkisi romanla sınırlı kalmamıştır. Eleştiri kuramında da Don Kişot’un yeri önemlidir. Marksist bir eleştirmen olan Lunacharsky; Özgürleştirilmiş Don Kişot adlı oyununun dışında, eleştiri yazılarında da Don Kişot'tan sık sık söz eder. Lukacs da Roman Kuramı adlı kitabında, Don Kişot karakteriyle soyut idealizmin romanı dediği bir roman türünü tanımlar. Bu arada Turgenev’in Hamlet ve Don Kişot karşılaştırmasını da unutmamak gerekir. Turgenev’e göre Hamlet ve Don Kişot iki zıt, fakat evrensel tipi temsil ederler: Düşünmekten bir türlü harekete geçemeyenle, hiç düşünmeden harekete geçeni. Shklovsky’nin de düzyazı kuramını yaparken Don Kişot'a verdiği önemi, Nabakov’un sık sık yaptığı atıfları anımsarsak bu kitabın Rusya’da hemen her dünya görüşünden yazara hitap etmiş olduğunu görürüz.
`,
          levels: [
            {
              level: 5,
              find: "Kişot",
            },
          ],
        },
        {
          metin: `Duygusal zeka açısından umutlu olmak; kişinin zorlu engeller veya yenilgiler karşısında bunaltıcı kaygıya, teslimiyetçi bir tutuma ya da depresyona yenik düşmemesi anlamına gelir. Gerçekten de, umut besleyebilen kişiler hedeflerine doğru ilerlerken diğerlerine oranla daha az depresif, genelde daha az kaygılı ve duygusal açıdan daha az sıkıntılı görünürler. İnsanların umutlarının derecesi kişiden kişiye farklılık gösterir. Snyder’a göre umutlu olan kişilerin kendilerini motive edebilme, köşeye sıkıştıklarında kendilerini “daha iyi günlerin geleceği” tesellisiyle yatıştırabilme, hedeflerine ulaşmak için değişik yollar bulabilme, imkansızlığı gördüklerinde hedef değiştirebilme ve zor bir işi baş edilebilir küçük parçalara bölebilme özellikleri bulunur. Umutlarını yitirmiş kişiler ise hedefe ulaşmak için gerekli olan enerji ve yetenekten yoksundur.
`,
          levels: [
            {
              find: "umut",
              level: 5,
            },
          ],
        },
        {
          metin: `Biçem, kişinin dili kullanma yetisine sıkı sıkıya bağlıdır. Çünkü yazma, sözcüklerle gerçekleştirilen bir davranıştır. sözcüklerin dünyasında yapılan bir yolculuktur. Hangi yazı vardır ki sözcükler evreninde yapılan bir yolculuğun ürünü olmasın? Kesinlemeye giderek söyleyeyim: Türü ne olursa olsun her yazı, sözcüklerin anlam ve çağrışım katmanlarında dolaşmayı zorunlu kılar. Yazar da bu katmanlarda dolaşan bir gezgindir bana göre. Sözcüklerin ülkesinde “yeni keşifler”e çıkan kişidir. Biçem sahibi olması, kendindenliğini oluşturması da buna, sözcüklerin coğrafyasını çok iyi tanımasına, o coğrafyanın havasını solumasına bağlıdır. Çünkü yazar, sözcüklerin ülkesini kendine yurt edinen kişidir.
`,
          levels: [
            {
              find: "sözcüklerin",
              level: 5,
            },
          ],
        },
        {
          metin: `Sanayi devrimiyle birlikte insanın çevre üzerindeki etkisi hız kazanmıştır. Sanayileşme çabası içindeki insanın fosil yakıtlara yönelmesi, nüfus artışı, şehirleşme, orman yangınları vb. sonucunda atmosferde artan sera gazları, günümüzde küresel ısınma problemini ortaya çıkarmıştır. Dünyada en çok karşılaşılan durum, insanların çeşitli etkinliklerinin atmosferin güneş enerjisini yutma ve yayma şeklini değiştirmesidir. Bu problemin varlığı, sanayi devriminin başlangıcından günümüze değin geçen süre içinde, ortalama küresel hava sıcaklığının artmasıyla kanıtlanmıştır. Sanayileşme öncesi güvenilir meteorolojik kayıtların tutulmaya başlandığı 1886’da 14,5 C olan dünyanın ortalama sıcaklığı 1995’te 15,4 C ye yükselmiştir. Sanayileşme bunda etkili bir unsurdur. 
`,
          levels: [
            {
              find: "sanayi",
              level: 5,
            },
          ],
        },
      ],
      options: [],
      currentLetter: null,
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      positions: [],
      totalTrue: 0,
      totalFalse: 0,
      counts: [],
      flash: false,
      answer: null,
      interval2: null,
      settings: false,
      autoLevel: 0,
      levelLock: false,
      totalClick: 0,
      totalItem: 0,
      totalTrueItem: 0,
      totalPickedTrueItem: 0,
      lastPickTime: new Date().getTime(),
      firstReactions: [],
      lock: false,
    };
  },
  created() {
    if (this.config != null && this.config != undefined) {
      if (this.config.level != null && this.config.level != "")
        this.level = this.config.level;
      if (this.config.speed != null && this.config.speed != "")
        this.speed = Math.max(10, this.config.speed);
      this.autoLevel = this.config.auto_level;
    }

    // test
    this.levels.map((level) => {
      var parts = level.metin.split(" ");
      level.levels.map((sublevel) => {
        if (
          parts.filter(
            (x) =>
              this.$slugify(x.trim()).search(
                this.$slugify(sublevel.find.trim())
              ) != -1
          ).length < sublevel.level
        ) {
          console.log("check failed", level, sublevel);
        }
      });
    });
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.start2();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    pick(index) {
      if(this.lock === true)
      return;
      this.totalClick += 1;
      if (
        this.options[index].slug.indexOf(
          this.$slugify(this.currentLetter.trim())
        ) != -1
      ) {
        if (
          !this.options.some(
            (k) =>
              k === this.$slugify(this.currentLetter.trim()) && k.picked == true
          )
        ) {
          this.firstReactions.push(new Date().getTime() - this.lastPickTime);
        }
        this.totalPickedTrueItem += 1;
      }
      this.options[index].picked = true;
      if (
        !this.options.some(
          (k) =>
            k.slug === this.$slugify(this.currentLetter.trim()) &&
            k.picked == false
        )
      ) {
        this.lock = true;
        clearInterval(this.interval);
        clearInterval(this.interval2);
        this.check();
      }
    },
    getColor(letter) {
      if (
        this.flash == true &&
        letter.slug == this.$slugify(this.currentLetter.trim()) &&
        letter.picked == false
      ) {
        return "white";
      }
      if (
        this.flash == true &&
        letter.slug == this.$slugify(this.currentLetter.trim()) &&
        letter.picked == true
      ) {
        return "rgb(28, 68, 156)";
      }
      if (
        this.flash == false &&
        letter.slug == this.$slugify(this.currentLetter.trim()) &&
        letter.picked == true
      ) {
        return "rgb(28, 68, 156)";
      }
      if (
        this.flash == false &&
        letter.slug != this.$slugify(this.currentLetter.trim()) &&
        letter.picked == true
      ) {
        console.log(letter.slug, this.$slugify(this.currentLetter.trim()));
        return "red";
      }
      if (
        this.flash == true &&
        letter.slug != this.$slugify(this.currentLetter.trim()) &&
        letter.picked == true
      ) {
        console.log(letter.slug, this.$slugify(this.currentLetter.trim()));
        return "red";
      }
    },
    check() {
      this.flash = true;
      if (
        !this.options.some(
          (k) =>
            k.slug == this.$slugify(this.currentLetter) && k.picked == false
        )
      ) {
        this.totalTrue += 1;
      } else {
        this.totalFalse += 1;
      }
      setTimeout(() => {
        this.start2();
      }, 3000);
    },
    start2() {
      this.lock = false;
      this.startCounter = 5;
      var levels = this.levels.filter((k) =>
        k.levels.some((x) => x.level == this.level)
      );
      levels = _.shuffle(levels);
      var rand = _.random(0, levels.length - 1);
      this.options = levels[rand].metin
        .split(" ")
        .filter((k) => k.trim() != "")
        .map((k) => {
          return {
            letter: k.trim(),
            picked: false,
            slug: this.$slugify(k.trim()),
          };
        });
      levels[rand].levels = _.shuffle(levels[rand].levels);
      var index = levels[rand].levels.findIndex((k) => k.level == this.level);
      this.currentLetter = levels[rand].levels[index].find;
      this.totalItem += this.options.length;
      this.totalTrueItem += this.options.filter(
        (k) => k.slug == this.$slugify(this.currentLetter.trim())
      ).length;
      this.interval2 = setInterval(() => {
        if (this.pause) return;
        this.startCounter -= 1;
        if (this.startCounter == 0) {
          clearInterval(this.interval2);
          this.interval2 = null;
          this.start();
        }
      }, 1000);
    },
    start() {
      this.flash = false;
      this.currentCounter = this.speed;
      this.lastPickTime = new Date().getTime();
      this.interval = setInterval(() => {
        if (this.pause) return;
        this.currentCounter -= 1;
        if (this.currentCounter == 0) {
          clearInterval(this.interval);
          this.flash = true;
          this.check();
        }
      }, 1000);
    },
    formatTooltip(val) {
      return val + " saniye";
    },
  },
  computed: {},
  watch: {
    totalPickedTrueItem: function (a, b) {
      if (this.totalPickedTrueItem == 0 || a == b) return;

      setTimeout(() => {
        $(".true-count").addClass("animate__animated animate__rubberBand");
        setTimeout(() => {
          $(".true-count").removeClass("animate__animated animate__rubberBand");
        }, 500);
      }, 100);
    },
    speed: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.interval2);
      this.start2();
    },
    level: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.interval2);
      this.start2();
    },
    totalTrue: function () {
      if (this.totalTrue % 2 == 0) {
        this.levelLock = true;
        this.speed = Math.max(
          this.speed - 5,
          this.config && this.config.max_speed ? this.config.max_speed : 10
        );
        this.level = Math.min(
          this.level + 1,
          this.config && this.config.max_level ? this.config.max_level : 5
        );
        setTimeout(() => {
          this.levelLock = false;
        }, 500);
      }
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  max-width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/KelimeAvi.vue